import { useEffect } from "react";
import { SetURLSearchParams } from "react-router-dom";
import { URLSearchParams } from "url";

export const useAutoUpdateQueryParam = (
  param: string,
  value: string | undefined,
  // if we call useSearchParams inside this hook, we'll get separate instances,
  // resulting in issues when 2 params are updated simultaneously in different instances
  setSearchParams: SetURLSearchParams,
) => {
  useEffect(() => {
    setSearchParams(
      (params: URLSearchParams) => {
        if (value) {
          params.set(param, value);
        } else {
          params.delete(param);
        }
        return params;
      },
      {
        replace: true,
      },
    );
    // eslint-disable-next-line
  }, [value]);
};
